import React from "react";
import "./Footer.css";
import Logo from "../Header/Logo";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="Footer">
      <div className="Footer--Inner">
        <div className="Footer--Brand">
          <Logo />
          <p className="Footer--Tagline">
            Восточная кухня, аромат специй и тепло гостеприимства — каждый день
            рядом с вами.
          </p>
        </div>

        <div className="Footer--Col">
          <div className="Footer--Title">Меню</div>
          <Link className="Footer--Link" to="/">
            Каталог
          </Link>
          <Link className="Footer--Link" to="/cart">
            Корзина
          </Link>
          <Link className="Footer--Link" to="/about">
            О нас
          </Link>
        </div>

        <div className="Footer--Col">
          <div className="Footer--Title">Контакты</div>
          <a className="Footer--Item" href="tel:+79248744506">
            <Phone size={16} />
            <span>+7 (924) 874-45-06</span>
          </a>
          <div className="Footer--Item">
            <MapPin size={16} />
            <span>г. Олёкминск, ул. Партизанская, д. 1</span>
          </div>
        </div>

        <div className="Footer--Col">
          <div className="Footer--Title">Режим работы</div>
          <div className="Footer--Item">
            <Clock size={16} />
            <span>Пн – Сб: 9:00 – 21:00</span>
          </div>
          <div className="Footer--Item">
            <Clock size={16} />
            <span>Вс: 12:00 – 21:00</span>
          </div>
        </div>
      </div>

      <div className="Footer--Bottom">
        <div className="Footer--Legal">
          <span>© {year} Шахризада. Все права защищены.</span>
          <a
            className="Footer--CopyrightLink"
            href="https://saturn-skyline.ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            АНО «ЦЦТ «Горизонт Сатурна» РС(Я) 2026
          </a>
        </div>
        <span className="Footer--Made">Сделано с любовью к гостям</span>
      </div>
    </footer>
  );
};

export default Footer;
